package music.jammers.client.shared.event.track.di

import music.jammers.client.shared.event.track.data.repository.EventTrackRepositoryImpl
import music.jammers.client.shared.event.track.domain.repository.EventTrackRepository
import music.jammers.client.shared.event.track.domain.usecase.AddEventTrackUseCase
import music.jammers.client.shared.event.track.domain.usecase.DeleteEventTrackUseCase
import music.jammers.client.shared.event.track.domain.usecase.GetEventTrackUseCase
import music.jammers.client.shared.event.track.domain.usecase.UpdateEventTrackUseCase
import music.jammers.client.shared.event.track.domain.usecase.ValidateEventTrackUseCase
import music.jammers.client.shared.event.track.domain.validator.EventTrackFieldValidator
import music.jammers.client.shared.event.track.presentation.viewmodel.AddEventTrackViewModel
import music.jammers.client.shared.event.track.presentation.viewmodel.EventTrackDetailsViewModel
import org.koin.core.component.KoinComponent
import org.koin.dsl.module

val eventTrackModule = module {
    factory {
        AddEventTrackViewModel(
            addEventTrackUseCase = get(),
            getEventDetailsUseCase = get(),
            eventTrackAnalytics = get(),
            eventTrackFieldValidator = get(),
            validateEventTrackUseCase = get(),
            router = get(),
        )
    }

    factory {
        EventTrackDetailsViewModel(
            getEventTrackUseCase = get(),
            updateEventTrackUseCase = get(),
            getEventDetailsUseCase = get(),
            deleteEventTrackUseCase = get(),
            getCurrentUserUseCase = get(),
            eventTrackFieldValidator = get(),
            validateEventTrackUseCase = get(),
            signInTrackUseCase = get(),
            signOutTrackUseCase = get(),
            eventAnalytics = get(),
            router = get(),
        )
    }

    factory {
        AddEventTrackUseCase(
            eventTrackRepository = get(),
        )
    }

    factory {
        GetEventTrackUseCase(
            eventTrackRepository = get(),
        )
    }

    factory {
        UpdateEventTrackUseCase(
            eventTrackRepository = get(),
        )
    }

    factory {
        DeleteEventTrackUseCase(
            eventTrackRepository = get(),
        )
    }

    factory {
        ValidateEventTrackUseCase(
            eventTrackFieldValidator = get(),
        )
    }

    factory {
        EventTrackFieldValidator()
    }

    single<EventTrackRepository> {
        EventTrackRepositoryImpl(
            httpClient = get(),
        )
    }
}

object EventTrackComponent : KoinComponent {

    val addEventTrackViewModel: AddEventTrackViewModel
        get() = getKoin().get<AddEventTrackViewModel>()

    val eventTrackDetailsViewModel: EventTrackDetailsViewModel
        get() = getKoin().get<EventTrackDetailsViewModel>()
}